import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import api from "../lib/api";
import { useWorkspace } from "../context/WorkspaceContext";

// Supervisor nudge: field users currently blocked by an ageing cap (hold a material past its
// type's max-days). Renders nothing when there are none. Reads a lightweight dedicated endpoint.
export default function AllocationAgeingBlocks() {
  const { ctx } = useWorkspace();
  const pid = ctx.project?.id;
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/dashboard/allocation-ageing-blocks", { params: pid ? { project_id: pid } : {} })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, [pid]);

  if (items.length === 0) return null;

  return (
    <div className="mt-6" data-testid="alloc-ageing-blocks">
      <div className="mb-3 flex items-center gap-2">
        <Clock className="h-4 w-4 text-red-600" />
        <h2 className="font-display text-lg font-semibold text-slate-900">Field Users Blocked (Ageing Cap)</h2>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it, i) => (
          <div key={`${it.field_user_id}-${i}`} data-testid={`ageing-block-${i}`}
            className="flex items-center justify-between rounded-lg border border-red-200 bg-red-50 px-3.5 py-2.5">
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-slate-800">{it.field_user_name}</span>
              <span className="block truncate text-xs text-slate-500">{it.type_name} · {it.project_name}</span>
            </span>
            <span className="shrink-0 pl-2 text-right">
              <span className="block font-display text-lg font-bold tabular-nums text-red-700">{it.aged_count}</span>
              <span className="block text-[10px] text-red-600">over {it.max_days}d</span>
            </span>
          </div>
        ))}
      </div>
      <p className="mt-1.5 text-xs text-slate-400">Blocked from receiving more of the listed type until they acknowledge or return the over-aged items.</p>
    </div>
  );
}
